import React, { useState, useEffect, useRef } from "react"; // ADDED: useRef import

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const Txt = ({ questionData, onOptionClick, video }) => {
  const { imageList, questionimagelist, questionaudio } = questionData;
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [images, setImages] = useState(shuffleArray([...questionimagelist]));
  const [originalOrder, setOriginalOrder] = useState(questionimagelist);
  const [isAnimating, setIsAnimating] = useState(false);

  // NEW CODE START: Ref for the question audio instance
  const questionAudioRef = useRef(null);
  // NEW CODE END

  // MODIFIED EFFECT HOOK: To manage the question audio instance
  useEffect(() => {
    // Cleanup previous audio instance if it exists
    if (questionAudioRef.current) {
      questionAudioRef.current.pause();
      questionAudioRef.current.currentTime = 0;
      questionAudioRef.current = null; // Clear the ref
    }

    if (questionaudio) {
      const audio = new Audio(questionaudio);
      audio.loop = false;
      audio.volume = 0.5;
      questionAudioRef.current = audio; // Store the new audio instance in the ref

      audio
        .play()
        .then(() => {
          console.log("Background audio started playing");
        })
        .catch((error) => {
          console.error("Error playing background audio:", error);
        });
    }

    // Cleanup function: pauses and resets the audio when component unmounts or questionaudio changes
    return () => {
      if (questionAudioRef.current) {
        questionAudioRef.current.pause();
        questionAudioRef.current.currentTime = 0;
      }
    };
  }, [questionaudio]); // Dependency array: runs when questionaudio changes

  const handleOptionClick = (index) => {
    if (selectedIndex === null) {
      setSelectedIndex(index);
    } else {
      const newImages = [...images];
      [newImages[selectedIndex], newImages[index]] = [
        newImages[index],
        newImages[selectedIndex],
      ];
      setIsAnimating(true);

      setTimeout(() => {
        setImages(newImages);
        setSelectedIndex(null);
        setIsAnimating(false);
        checkOrderMatch(newImages);
      }, 300);
    }
  };

  const checkOrderMatch = (newImages) => {
    const isMatch = JSON.stringify(newImages) === JSON.stringify(originalOrder);
    if (isMatch) {
      console.log("The order matches the original order.");
    } else {
      console.log("The order does not match the original order.");
    }
  };

  const checkArrangement = () => {
    const isCorrect = JSON.stringify(images) === JSON.stringify(originalOrder);
    // console.log("Current order:", images);
    // console.log("Original order:", originalOrder);
    onOptionClick(isCorrect ? "0" : "1"); // Pass "0" for correct, "1" for incorrect
  };

  useEffect(() => {
    checkArrangement();
  }, [images]); // Depend on 'images' to re-check arrangement when they change

  return (
    <div className="flex w-[70%] mt-[20px] h-[87%] flex-col items-center justify-center font-mali">
      {imageList && (
        <img className="w-[30%] p-10" src={imageList} alt="Question" />
      )}

      <div className="grid grid-cols-2 gap-1 w-[25%]">
        {images &&
          images.map((image, index) => (
            <div
              key={index}
              className={`relative transition-transform duration-300 ease-in-out ${
                isAnimating && selectedIndex !== null
                  ? "transition-transform"
                  : ""
              } ${
                selectedIndex === index
                  ? "scale-105 border-2 border-blue-500"
                  : "hover:scale-105"
              }`}
              onClick={() => handleOptionClick(index)}
            >
              <img
                className={`w-full h-auto cursor-pointer transition-all duration-300 ease-in-out ${
                  selectedIndex === index ? "opacity-100" : "opacity-90"
                }`}
                src={image}
                alt={`Option ${index + 1}`}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default Txt;
